import { Badge, BadgeSize } from '@eppendorf/vnls-react-components';
import { useTranslation } from 'react-i18next';

export enum RouterStatus {
  ONLINE = 'online',
  WEAK_SIGNAL = 'weaksignal',
  TIMEOUT = 'timeout',
  BLOCKED = 'blocked',
  OFFLINE = 'offline',
}

interface Props {
  status: RouterStatus | string;
  size?: BadgeSize;
}

export function RouterStatusBadge({ status, size = 'small' }: Props) {
  const { t } = useTranslation();

  switch (status) {
    case RouterStatus.BLOCKED:
      return (
        <Badge color="blue" size={size}>
          {t('deviceDetail.routerStatus.blocked')}
        </Badge>
      );
    case RouterStatus.ONLINE:
      return (
        <Badge color="green" size={size}>
          {t('deviceDetail.routerStatus.stable')}
        </Badge>
      );
    case RouterStatus.TIMEOUT:
    case RouterStatus.OFFLINE:
      return <Badge size={size}>{t('deviceDetail.routerStatus.noConnection')}</Badge>;
    case RouterStatus.WEAK_SIGNAL:
      return (
        <Badge color="red" size={size}>
          {t('deviceDetail.routerStatus.unstable')}
        </Badge>
      );
    default:
      return '';
  }
}
